import { render, staticRenderFns } from "./OTForm.vue?vue&type=template&id=627551d9&scoped=true&lang=pug"
import script from "./OTForm.vue?vue&type=script&lang=js"
export * from "./OTForm.vue?vue&type=script&lang=js"
import style0 from "./OTForm.vue?vue&type=style&index=0&id=627551d9&prod&lang=scss&scoped=true"
import style1 from "./OTForm.vue?vue&type=style&index=1&id=627551d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627551d9",
  null
  
)

export default component.exports